import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import { configureStore } from './store';

ReactDOM.render((
  <Provider store={configureStore()}>
    <BrowserRouter>
      <Switch>
				<Route path="/" component={App} />
			</Switch>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

serviceWorker.unregister();
